export const deliveryIcon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="4" fill="#FCE5C5" />
    <path
      d="M8.49107 24.4542H23.4375V26.9453H8.49107V24.4542ZM6 18.2266H18.4554V20.7176H6V18.2266Z"
      fill="#F69913"
    />
    <path
      d="M40.7741 25.2102L37.0375 16.4914C36.9414 16.2674 36.7818 16.0765 36.5784 15.9423C36.3749 15.8082 36.1365 15.7366 35.8928 15.7366H32.1562V13.2455C32.1562 12.9152 32.025 12.5984 31.7914 12.3648C31.5578 12.1312 31.241 12 30.9107 12H10.9821V14.4911H29.6651V30.13C29.0979 30.46 28.6015 30.8988 28.2044 31.4212C27.8072 31.9436 27.5172 32.5393 27.3509 33.1741H19.524C19.2208 32 18.4999 30.9768 17.4962 30.2962C16.4926 29.6156 15.2752 29.3244 14.0723 29.4772C12.8693 29.63 11.7634 30.2163 10.9618 31.1262C10.1602 32.036 9.7179 33.207 9.7179 34.4197C9.7179 35.6323 10.1602 36.8033 10.9618 37.7131C11.7634 38.623 12.8693 39.2093 14.0723 39.3621C15.2752 39.5149 16.4926 39.2237 17.4962 38.5431C18.4999 37.8626 19.2208 36.8393 19.524 35.6652H27.3509C27.6219 36.7342 28.2415 37.6823 29.1118 38.3595C29.9822 39.0367 31.0534 39.4045 32.1562 39.4045C33.259 39.4045 34.3303 39.0367 35.2006 38.3595C36.0709 37.6823 36.6905 36.7342 36.9615 35.6652H39.6294C39.9598 35.6652 40.2766 35.534 40.5102 35.3004C40.7437 35.0668 40.875 34.75 40.875 34.4197V25.7009C40.8749 25.5322 40.8406 25.3652 40.7741 25.2102ZM14.7187 36.9107C14.226 36.9107 13.7444 36.7646 13.3347 36.4909C12.9251 36.2172 12.6058 35.8281 12.4173 35.3729C12.2287 34.9178 12.1794 34.4169 12.2755 33.9337C12.3716 33.4505 12.6089 33.0066 12.9572 32.6582C13.3056 32.3098 13.7495 32.0726 14.2327 31.9764C14.7159 31.8803 15.2168 31.9297 15.672 32.1182C16.1272 32.3067 16.5162 32.626 16.79 33.0357C17.0637 33.4453 17.2098 33.927 17.2098 34.4197C17.2098 35.0803 16.9473 35.7139 16.4802 36.1811C16.013 36.6483 15.3794 36.9107 14.7187 36.9107ZM32.1562 18.2277H35.0708L37.7412 24.4554H32.1562V18.2277ZM32.1562 36.9107C31.6635 36.9107 31.1819 36.7646 30.7722 36.4909C30.3626 36.2172 30.0433 35.8281 29.8548 35.3729C29.6662 34.9178 29.6169 34.4169 29.713 33.9337C29.8091 33.4505 30.0464 33.0066 30.3948 32.6582C30.7431 32.3098 31.187 32.0726 31.6702 31.9764C32.1535 31.8803 32.6543 31.9297 33.1095 32.1182C33.5647 32.3067 33.9537 32.626 34.2275 33.0357C34.5012 33.4453 34.6473 33.927 34.6473 34.4197C34.6473 35.0803 34.3848 35.7139 33.9177 36.1811C33.4505 36.6483 32.8169 36.9107 32.1562 36.9107ZM38.3839 33.1741H36.9615C36.6871 32.1072 36.0665 31.1616 35.1969 30.4853C34.3272 29.8091 33.2578 29.4406 32.1562 29.4375V26.9464H38.3839V33.1741Z"
      fill="#F69913"
    />
  </svg>
);

export const boxIcon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="4" fill="#FFD3DA" />
    <path
      d="M40 17.5L25 10L10 17.5V32.5L25 40L40 32.5V17.5Z"
      stroke="#E43754"
      stroke-width="1.44"
      stroke-linejoin="round"
    />
    <path
      d="M10 17.5046L25 25.0046M25 25.0046V40.0046M25 25.0046L40 17.5046M32.5 13.7546L17.5 21.2546"
      stroke="#E43754"
      stroke-width="1.44"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const greenBoxIcon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="4" fill="#D7FDF5" />
    <path
      d="M25 24.6484V38.6963L24.0625 39.165L11.875 33.0859V17.8516L24.0625 11.7578L36.25 17.8516V28.75H34.375V19.9609L25 24.6484ZM24.0625 13.8672L20.5322 15.625L29.6289 20.2246L33.2178 18.4375L24.0625 13.8672ZM23.125 36.6016V24.6484L13.75 19.9609V31.9141L23.125 36.6016ZM14.9072 18.4375L24.0625 23.0078L27.5488 21.2793L18.4375 16.6797L14.9072 18.4375ZM30.625 36.25V34.375H40V36.25H30.625ZM30.625 30.625H40V32.5H30.625V30.625ZM26.875 40V38.125H28.75V40H26.875ZM26.875 32.5V30.625H28.75V32.5H26.875ZM26.875 36.25V34.375H28.75V36.25H26.875ZM30.625 40V38.125H40V40H30.625Z"
      fill="#015A49"
    />
  </svg>
);

// ******** Admin Dashboard Icons ***********
export const checkBlueIcon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="25" fill="#D8E7FF" />
    <path
      d="M25 11.25L13.75 16.25V23.75C13.75 30.6875 18.55 37.175 25 38.75C31.45 37.175 36.25 30.6875 36.25 23.75V16.25L25 11.25ZM33.75 23.75C33.75 29.4 30.025 34.6125 25 36.1625C19.975 34.6125 16.25 29.4 16.25 23.75V17.875L25 13.9875L33.75 17.875V23.75ZM19.2625 24.4875L17.5 26.25L22.5 31.25L32.5 21.25L30.7375 19.475L22.5 27.7125L19.2625 24.4875Z"
      fill="#3B82F6"
    />
  </svg>
);

export const checkGreenIcon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="25" fill="#16A34A" fill-opacity="0.2" />
    <path
      d="M25 11.25L13.75 16.25V23.75C13.75 30.6875 18.55 37.175 25 38.75C31.45 37.175 36.25 30.6875 36.25 23.75V16.25L25 11.25ZM33.75 23.75C33.75 29.4 30.025 34.6125 25 36.1625C19.975 34.6125 16.25 29.4 16.25 23.75V17.875L25 13.9875L33.75 17.875V23.75ZM19.2625 24.4875L17.5 26.25L22.5 31.25L32.5 21.25L30.7375 19.475L22.5 27.7125L19.2625 24.4875Z"
      fill="#16A34A"
    />
  </svg>
);

export const checkOrangeIcon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="25" fill="#FFB24A" fill-opacity="0.2" />
    <path
      d="M25 11.25L13.75 16.25V23.75C13.75 30.6875 18.55 37.175 25 38.75C31.45 37.175 36.25 30.6875 36.25 23.75V16.25L25 11.25ZM33.75 23.75C33.75 29.4 30.025 34.6125 25 36.1625C19.975 34.6125 16.25 29.4 16.25 23.75V17.875L25 13.9875L33.75 17.875V23.75ZM19.2625 24.4875L17.5 26.25L22.5 31.25L32.5 21.25L30.7375 19.475L22.5 27.7125L19.2625 24.4875Z"
      fill="#FFB24A"
    />
  </svg>
);

export const transactionIconGreen = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="25" fill="#00D522" fill-opacity="0.2" />
    <path
      d="M12.5 18.75H35M30 12.5L36.25 18.75L30 25M37.5 31.25H15M20 25L13.75 31.25L20 37.5"
      stroke="#00D522"
      stroke-width="2"
    />
  </svg>
);

export const transactionIconBlue = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="25" fill="#3B82F6" fill-opacity="0.2" />
    <path
      d="M12.5 18.75H35M30 12.5L36.25 18.75L30 25M37.5 31.25H15M20 25L13.75 31.25L20 37.5"
      stroke="#3B82F6"
      stroke-width="2"
    />
  </svg>
);

export const transactionIconRed = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="25" fill="#FF4545" fill-opacity="0.2" />
    <path
      d="M12.5 18.75H35M30 12.5L36.25 18.75L30 25M37.5 31.25H15M20 25L13.75 31.25L20 37.5"
      stroke="#FF4545"
      stroke-width="2"
    />
  </svg>
);

export const chartIcon = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="25" height="25" rx="4" fill="#EBE2FF" />
    <path
      d="M19.8537 18.464H3.17024C3.07661 18.464 3 18.5406 3 18.6343V19.826C3 19.9196 3.07661 19.9962 3.17024 19.9962H19.8537C19.9474 19.9962 20.024 19.9196 20.024 19.826V18.6343C20.024 18.5406 19.9474 18.464 19.8537 18.464ZM4.14273 15.7998L4.98755 16.6403C5.05352 16.7063 5.16205 16.7063 5.22801 16.6403L10.2224 11.663L12.2993 13.7335C12.4273 13.8603 12.6001 13.9314 12.7803 13.9314C12.9604 13.9314 13.1332 13.8603 13.2612 13.7335L18.8834 8.13261C18.9493 8.06664 18.9493 7.95811 18.8834 7.89214L18.0386 7.04945C18.0066 7.01777 17.9634 7 17.9183 7C17.8733 7 17.8301 7.01777 17.7981 7.04945L12.7824 12.0502L10.7034 9.97971C10.5754 9.85293 10.4026 9.7818 10.2224 9.7818C10.0423 9.7818 9.86945 9.85293 9.7415 9.97971L4.14273 15.5593C4.12682 15.575 4.11418 15.5938 4.10555 15.6144C4.09693 15.635 4.09248 15.6572 4.09248 15.6795C4.09248 15.7019 4.09693 15.7241 4.10555 15.7447C4.11418 15.7653 4.12682 15.7841 4.14273 15.7998Z"
      fill="#28105B"
    />
  </svg>
);

// ******** DRF USER MANAGEMENT Icons ***********
export const userBlue = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#43A047" fill-opacity="0.2" />
    <path
      d="M15.5 17.8332C13.9042 17.8332 12.4975 18.6373 11.5067 19.704C10.5217 20.7648 9.875 22.1607 9.875 23.4582C9.875 23.8032 10.155 24.0832 10.5 24.0832H20.5C20.6658 24.0832 20.8247 24.0173 20.9419 23.9001C21.0592 23.7829 21.125 23.6239 21.125 23.4582C21.125 22.1598 20.4792 20.7648 19.4933 19.704C18.5017 18.6373 17.0958 17.8332 15.5 17.8332ZM22.3367 18.084C22.1771 18.0389 22.0061 18.0591 21.8614 18.14C21.7167 18.221 21.6101 18.3561 21.565 18.5157C21.5199 18.6752 21.5401 18.8462 21.621 18.9909C21.702 19.1356 21.8371 19.2423 21.9967 19.2873C22.7742 19.5073 23.4975 20.1365 24.0383 20.9657C24.5775 21.7948 24.875 22.734 24.875 23.4573C24.875 23.6231 24.9408 23.7821 25.0581 23.8993C25.1753 24.0165 25.3342 24.0823 25.5 24.0823C25.6658 24.0823 25.8247 24.0165 25.9419 23.8993C26.0592 23.7821 26.125 23.6231 26.125 23.4573C26.125 22.4407 25.7267 21.2682 25.085 20.284C24.4442 19.2998 23.5017 18.414 22.3367 18.084ZM15.5 9.9165C15.0896 9.9165 14.6833 9.99733 14.3041 10.1544C13.925 10.3114 13.5805 10.5416 13.2903 10.8318C13.0001 11.122 12.7699 11.4665 12.6129 11.8456C12.4558 12.2248 12.375 12.6311 12.375 13.0415C12.375 13.4519 12.4558 13.8582 12.6129 14.2374C12.7699 14.6165 13.0001 14.961 13.2903 15.2512C13.5805 15.5414 13.925 15.7716 14.3041 15.9286C14.6833 16.0857 15.0896 16.1665 15.5 16.1665C16.3288 16.1665 17.1237 15.8373 17.7097 15.2512C18.2958 14.6652 18.625 13.8703 18.625 13.0415C18.625 12.2127 18.2958 11.4178 17.7097 10.8318C17.1237 10.2457 16.3288 9.9165 15.5 9.9165ZM20.5 9.9165C20.3342 9.9165 20.1753 9.98235 20.0581 10.0996C19.9408 10.2168 19.875 10.3757 19.875 10.5415V15.5415C19.875 15.8865 20.155 16.1665 20.5 16.1665C20.9104 16.1665 21.3167 16.0857 21.6959 15.9286C22.075 15.7716 22.4195 15.5414 22.7097 15.2512C22.9999 14.961 23.2301 14.6165 23.3871 14.2374C23.5442 13.8582 23.625 13.4519 23.625 13.0415C23.625 12.6311 23.5442 12.2248 23.3871 11.8456C23.2301 11.4665 22.9999 11.122 22.7097 10.8318C22.4195 10.5416 22.075 10.3114 21.6959 10.1544C21.3167 9.99733 20.9104 9.9165 20.5 9.9165Z"
      fill="#43A047"
    />
  </svg>
);

export const userGreen = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#E6F7EC" />
    <path
      d="M15.5 17.8332C13.9042 17.8332 12.4975 18.6373 11.5067 19.704C10.5217 20.7648 9.875 22.1607 9.875 23.4582C9.875 23.8032 10.155 24.0832 10.5 24.0832H20.5C20.6658 24.0832 20.8247 24.0173 20.9419 23.9001C21.0592 23.7829 21.125 23.6239 21.125 23.4582C21.125 22.1598 20.4792 20.7648 19.4933 19.704C18.5017 18.6373 17.0958 17.8332 15.5 17.8332ZM22.3367 18.084C22.1771 18.0389 22.0061 18.0591 21.8614 18.14C21.7167 18.221 21.6101 18.3561 21.565 18.5157C21.5199 18.6752 21.5401 18.8462 21.621 18.9909C21.702 19.1356 21.8371 19.2423 21.9967 19.2873C22.7742 19.5073 23.4975 20.1365 24.0383 20.9657C24.5775 21.7948 24.875 22.734 24.875 23.4573C24.875 23.6231 24.9408 23.7821 25.0581 23.8993C25.1753 24.0165 25.3342 24.0823 25.5 24.0823C25.6658 24.0823 25.8247 24.0165 25.9419 23.8993C26.0592 23.7821 26.125 23.6231 26.125 23.4573C26.125 22.4407 25.7267 21.2682 25.085 20.284C24.4442 19.2998 23.5017 18.414 22.3367 18.084ZM15.5 9.9165C15.0896 9.9165 14.6833 9.99733 14.3041 10.1544C13.925 10.3114 13.5805 10.5416 13.2903 10.8318C13.0001 11.122 12.7699 11.4665 12.6129 11.8456C12.4558 12.2248 12.375 12.6311 12.375 13.0415C12.375 13.4519 12.4558 13.8582 12.6129 14.2374C12.7699 14.6165 13.0001 14.961 13.2903 15.2512C13.5805 15.5414 13.925 15.7716 14.3041 15.9286C14.6833 16.0857 15.0896 16.1665 15.5 16.1665C16.3288 16.1665 17.1237 15.8373 17.7097 15.2512C18.2958 14.6652 18.625 13.8703 18.625 13.0415C18.625 12.2127 18.2958 11.4178 17.7097 10.8318C17.1237 10.2457 16.3288 9.9165 15.5 9.9165ZM20.5 9.9165C20.3342 9.9165 20.1753 9.98235 20.0581 10.0996C19.9408 10.2168 19.875 10.3757 19.875 10.5415V15.5415C19.875 15.8865 20.155 16.1665 20.5 16.1665C20.9104 16.1665 21.3167 16.0857 21.6959 15.9286C22.075 15.7716 22.4195 15.5414 22.7097 15.2512C22.9999 14.961 23.2301 14.6165 23.3871 14.2374C23.5442 13.8582 23.625 13.4519 23.625 13.0415C23.625 12.6311 23.5442 12.2248 23.3871 11.8456C23.2301 11.4665 22.9999 11.122 22.7097 10.8318C22.4195 10.5416 22.075 10.3114 21.6959 10.1544C21.3167 9.99733 20.9104 9.9165 20.5 9.9165Z"
      fill="#2196F3"
    />
  </svg>
);

export const userOrange = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#FB8C00" fill-opacity="0.2" />
    <path
      d="M15.5 18.8332C13.9042 18.8332 12.4975 19.6373 11.5067 20.704C10.5217 21.7648 9.875 23.1607 9.875 24.4582C9.875 24.8032 10.155 25.0832 10.5 25.0832H20.5C20.6658 25.0832 20.8247 25.0173 20.9419 24.9001C21.0592 24.7829 21.125 24.6239 21.125 24.4582C21.125 23.1598 20.4792 21.7648 19.4933 20.704C18.5017 19.6373 17.0958 18.8332 15.5 18.8332ZM22.3367 19.084C22.1771 19.0389 22.0061 19.0591 21.8614 19.14C21.7167 19.221 21.6101 19.3561 21.565 19.5157C21.5199 19.6752 21.5401 19.8462 21.621 19.9909C21.702 20.1356 21.8371 20.2423 21.9967 20.2873C22.7742 20.5073 23.4975 21.1365 24.0383 21.9657C24.5775 22.7948 24.875 23.734 24.875 24.4573C24.875 24.6231 24.9408 24.7821 25.0581 24.8993C25.1753 25.0165 25.3342 25.0823 25.5 25.0823C25.6658 25.0823 25.8247 25.0165 25.9419 24.8993C26.0592 24.7821 26.125 24.6231 26.125 24.4573C26.125 23.4407 25.7267 22.2682 25.085 21.284C24.4442 20.2998 23.5017 19.414 22.3367 19.084ZM15.5 10.9165C15.0896 10.9165 14.6833 10.9973 14.3041 11.1544C13.925 11.3114 13.5805 11.5416 13.2903 11.8318C13.0001 12.122 12.7699 12.4665 12.6129 12.8456C12.4558 13.2248 12.375 13.6311 12.375 14.0415C12.375 14.4519 12.4558 14.8582 12.6129 15.2374C12.7699 15.6165 13.0001 15.961 13.2903 16.2512C13.5805 16.5414 13.925 16.7716 14.3041 16.9286C14.6833 17.0857 15.0896 17.1665 15.5 17.1665C16.3288 17.1665 17.1237 16.8373 17.7097 16.2512C18.2958 15.6652 18.625 14.8703 18.625 14.0415C18.625 13.2127 18.2958 12.4178 17.7097 11.8318C17.1237 11.2457 16.3288 10.9165 15.5 10.9165ZM20.5 10.9165C20.3342 10.9165 20.1753 10.9824 20.0581 11.0996C19.9408 11.2168 19.875 11.3757 19.875 11.5415V16.5415C19.875 16.8865 20.155 17.1665 20.5 17.1665C20.9104 17.1665 21.3167 17.0857 21.6959 16.9286C22.075 16.7716 22.4195 16.5414 22.7097 16.2512C22.9999 15.961 23.2301 15.6165 23.3871 15.2374C23.5442 14.8582 23.625 14.4519 23.625 14.0415C23.625 13.6311 23.5442 13.2248 23.3871 12.8456C23.2301 12.4665 22.9999 12.122 22.7097 11.8318C22.4195 11.5416 22.075 11.3114 21.6959 11.1544C21.3167 10.9973 20.9104 10.9165 20.5 10.9165Z"
      fill="#FB8C00"
    />
  </svg>
);

export const userRed = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#E53935" fill-opacity="0.2" />
    <path
      d="M15.5 18.8332C13.9042 18.8332 12.4975 19.6373 11.5067 20.704C10.5217 21.7648 9.875 23.1607 9.875 24.4582C9.875 24.8032 10.155 25.0832 10.5 25.0832H20.5C20.6658 25.0832 20.8247 25.0173 20.9419 24.9001C21.0592 24.7829 21.125 24.6239 21.125 24.4582C21.125 23.1598 20.4792 21.7648 19.4933 20.704C18.5017 19.6373 17.0958 18.8332 15.5 18.8332ZM22.3367 19.084C22.1771 19.0389 22.0061 19.0591 21.8614 19.14C21.7167 19.221 21.6101 19.3561 21.565 19.5157C21.5199 19.6752 21.5401 19.8462 21.621 19.9909C21.702 20.1356 21.8371 20.2423 21.9967 20.2873C22.7742 20.5073 23.4975 21.1365 24.0383 21.9657C24.5775 22.7948 24.875 23.734 24.875 24.4573C24.875 24.6231 24.9408 24.7821 25.0581 24.8993C25.1753 25.0165 25.3342 25.0823 25.5 25.0823C25.6658 25.0823 25.8247 25.0165 25.9419 24.8993C26.0592 24.7821 26.125 24.6231 26.125 24.4573C26.125 23.4407 25.7267 22.2682 25.085 21.284C24.4442 20.2998 23.5017 19.414 22.3367 19.084ZM15.5 10.9165C15.0896 10.9165 14.6833 10.9973 14.3041 11.1544C13.925 11.3114 13.5805 11.5416 13.2903 11.8318C13.0001 12.122 12.7699 12.4665 12.6129 12.8456C12.4558 13.2248 12.375 13.6311 12.375 14.0415C12.375 14.4519 12.4558 14.8582 12.6129 15.2374C12.7699 15.6165 13.0001 15.961 13.2903 16.2512C13.5805 16.5414 13.925 16.7716 14.3041 16.9286C14.6833 17.0857 15.0896 17.1665 15.5 17.1665C16.3288 17.1665 17.1237 16.8373 17.7097 16.2512C18.2958 15.6652 18.625 14.8703 18.625 14.0415C18.625 13.2127 18.2958 12.4178 17.7097 11.8318C17.1237 11.2457 16.3288 10.9165 15.5 10.9165ZM20.5 10.9165C20.3342 10.9165 20.1753 10.9824 20.0581 11.0996C19.9408 11.2168 19.875 11.3757 19.875 11.5415V16.5415C19.875 16.8865 20.155 17.1665 20.5 17.1665C20.9104 17.1665 21.3167 17.0857 21.6959 16.9286C22.075 16.7716 22.4195 16.5414 22.7097 16.2512C22.9999 15.961 23.2301 15.6165 23.3871 15.2374C23.5442 14.8582 23.625 14.4519 23.625 14.0415C23.625 13.6311 23.5442 13.2248 23.3871 12.8456C23.2301 12.4665 22.9999 12.122 22.7097 11.8318C22.4195 11.5416 22.075 11.3114 21.6959 11.1544C21.3167 10.9973 20.9104 10.9165 20.5 10.9165Z"
      fill="#E53935"
    />
  </svg>
);

// ******** DRF Dashboard Icons ***********
export const greenWallet = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#E6F7EC" />
    <path
      d="M12.1667 9.5C11.7246 9.5 11.3007 9.67559 10.9882 9.98816C10.6756 10.3007 10.5 10.7246 10.5 11.1667V22.8333C10.5 23.2754 10.6756 23.6993 10.9882 24.0118C11.3007 24.3244 11.7246 24.5 12.1667 24.5H23.8333C24.2754 24.5 24.6993 24.3244 25.0118 24.0118C25.3244 23.6993 25.5 23.2754 25.5 22.8333V20.9333C25.7519 20.7879 25.9613 20.5791 26.1075 20.3276C26.2537 20.0762 26.3316 19.7909 26.3333 19.5V14.5C26.3316 14.2091 26.2537 13.9238 26.1075 13.6724C25.9613 13.4209 25.7519 13.2121 25.5 13.0667V11.1667C25.5 10.7246 25.3244 10.3007 25.0118 9.98816C24.6993 9.67559 24.2754 9.5 23.8333 9.5H12.1667ZM12.1667 11.1667H23.8333V12.8333H18.8333C18.3913 12.8333 17.9674 13.0089 17.6548 13.3215C17.3423 13.634 17.1667 14.058 17.1667 14.5V19.5C17.1667 19.942 17.3423 20.3659 17.6548 20.6785C17.9674 20.9911 18.3913 21.1667 18.8333 21.1667H23.8333V22.8333H12.1667V11.1667ZM18.8333 14.5H24.6667V19.5H18.8333V14.5ZM21.3333 15.75C21.0018 15.75 20.6839 15.8817 20.4494 16.1161C20.215 16.3505 20.0833 16.6685 20.0833 17C20.0833 17.3315 20.215 17.6495 20.4494 17.8839C20.6839 18.1183 21.0018 18.25 21.3333 18.25C21.6649 18.25 21.9828 18.1183 22.2172 17.8839C22.4516 17.6495 22.5833 17.3315 22.5833 17C22.5833 16.6685 22.4516 16.3505 22.2172 16.1161C21.9828 15.8817 21.6649 15.75 21.3333 15.75Z"
      fill="#00C853"
    />
  </svg>
);

export const orangeCoin = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#FFF6C9" />
    <path
      d="M13.8332 13.2499C16.1344 13.2499 17.9998 12.3172 17.9998 11.1666C17.9998 10.016 16.1344 9.08325 13.8332 9.08325C11.532 9.08325 9.6665 10.016 9.6665 11.1666C9.6665 12.3172 11.532 13.2499 13.8332 13.2499Z"
      stroke="#DBBE2C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.6665 11.1665C9.6665 11.1665 9.6665 12.9326 9.6665 14.0832C9.6665 15.2338 11.532 16.1665 13.8332 16.1665C16.1343 16.1665 17.9998 15.2338 17.9998 14.0832C17.9998 13.4017 17.9998 11.1665 17.9998 11.1665"
      stroke="#DBBE2C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.6665 14.0833C9.6665 14.0833 9.6665 15.8493 9.6665 16.9999C9.6665 18.1505 11.532 19.0833 13.8332 19.0833C16.1343 19.0833 17.9998 18.1505 17.9998 16.9999C17.9998 16.3184 17.9998 14.0833 17.9998 14.0833"
      stroke="#DBBE2C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.6665 17C9.6665 17 9.6665 18.7661 9.6665 19.9167C9.6665 21.0672 11.532 22 13.8332 22C16.1343 22 17.9998 21.0672 17.9998 19.9167C17.9998 19.2352 17.9998 17 17.9998 17"
      stroke="#DBBE2C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.6665 19.9165C9.6665 19.9165 9.6665 21.6826 9.6665 22.8332C9.6665 23.9838 11.532 24.9165 13.8332 24.9165C16.1343 24.9165 17.9998 23.9838 17.9998 22.8332C17.9998 22.1517 17.9998 19.9165 17.9998 19.9165"
      stroke="#DBBE2C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.1667 19.0832C24.4679 19.0832 26.3333 18.1504 26.3333 16.9998C26.3333 15.8492 24.4679 14.9165 22.1667 14.9165C19.8655 14.9165 18 15.8492 18 16.9998C18 18.1504 19.8655 19.0832 22.1667 19.0832Z"
      stroke="#DBBE2C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 17C18 17 18 18.7661 18 19.9167C18 21.0672 19.8655 22 22.1667 22C24.4678 22 26.3333 21.0672 26.3333 19.9167C26.3333 19.2352 26.3333 17 26.3333 17"
      stroke="#DBBE2C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 19.9165C18 19.9165 18 21.6826 18 22.8332C18 23.9838 19.8655 24.9165 22.1667 24.9165C24.4678 24.9165 26.3333 23.9838 26.3333 22.8332C26.3333 22.1517 26.3333 19.9165 26.3333 19.9165"
      stroke="#DBBE2C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const purpleGrowth = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#C8D0FF" />
    <path
      d="M11.6752 20.1049L14.5102 17.2699L16.8677 19.6274L19.4985 16.9966L18.0044 15.5024H22.171V19.6691L20.6769 18.1749L16.8677 21.9841L14.5102 19.6274L12.4485 21.6891C13.3847 23.0981 14.8216 24.0986 16.4679 24.4877C18.1142 24.8768 19.8469 24.6255 21.3149 23.7847C22.7828 22.9438 23.8762 21.5764 24.3735 19.9594C24.8708 18.3425 24.7347 16.5969 23.9929 15.0765C23.2511 13.5561 21.9591 12.3746 20.3786 11.7714C18.7981 11.1681 17.0474 11.1883 15.4812 11.8278C13.915 12.4673 12.6505 13.6783 11.944 15.2154C11.2374 16.7525 11.1416 18.5007 11.676 20.1058M10.3952 21.4041L10.3869 21.3958L10.3902 21.3924C9.91598 20.3255 9.67125 19.1708 9.67188 18.0033C9.67188 13.4008 13.4027 9.66992 18.0052 9.66992C22.6077 9.66992 26.3385 13.4008 26.3385 18.0033C26.3385 22.6058 22.6077 26.3366 18.0052 26.3366C14.6135 26.3366 11.6969 24.3116 10.3952 21.4041Z"
      fill="#1E37D9"
    />
  </svg>
);
export const orangeGrowth = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#FFB300" fill-opacity="0.2" />
    <path
      d="M11.6752 20.1049L14.5102 17.2699L16.8677 19.6274L19.4985 16.9966L18.0044 15.5024H22.171V19.6691L20.6769 18.1749L16.8677 21.9841L14.5102 19.6274L12.4485 21.6891C13.3847 23.0981 14.8216 24.0986 16.4679 24.4877C18.1142 24.8768 19.8469 24.6255 21.3149 23.7847C22.7828 22.9438 23.8762 21.5764 24.3735 19.9594C24.8708 18.3425 24.7347 16.5969 23.9929 15.0765C23.2511 13.5561 21.9591 12.3746 20.3786 11.7714C18.7981 11.1681 17.0474 11.1883 15.4812 11.8278C13.915 12.4673 12.6505 13.6783 11.944 15.2154C11.2374 16.7525 11.1416 18.5007 11.676 20.1058M10.3952 21.4041L10.3869 21.3958L10.3902 21.3924C9.91598 20.3255 9.67125 19.1708 9.67188 18.0033C9.67188 13.4008 13.4027 9.66992 18.0052 9.66992C22.6077 9.66992 26.3385 13.4008 26.3385 18.0033C26.3385 22.6058 22.6077 26.3366 18.0052 26.3366C14.6135 26.3366 11.6969 24.3116 10.3952 21.4041Z"
      fill="#FFB300"
    />
  </svg>
);

// ******** Pharmacy Dashboard Icons ***********
export const orangeDrug = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#FFF6C9" />
    <path
      d="M21.4999 9.91669C20.6666 9.08335 19.5833 8.66669 18.5833 8.66669C17.5833 8.66669 16.4166 9.08335 15.6666 9.91669L10.8333 14.5834C9.16659 16.25 9.16659 18.8334 10.8333 20.5C12.4999 22.1667 15.0833 22.1667 16.7499 20.5L21.4999 15.75C23.0833 14.1667 23.0833 11.5 21.4999 9.91669ZM20.3333 14.5834L17.9999 16.9167L14.9999 14L11.3333 17.6667C11.3333 17 11.4999 16.25 12.0833 15.75L16.8333 11C17.2499 10.5834 17.9166 10.3334 18.4999 10.3334C19.0833 10.3334 19.7499 10.5834 20.2499 11C21.2499 12.0834 21.2499 13.5834 20.3333 14.5834ZM24.3333 12.9167C24.3333 13.5834 24.1666 14.1667 23.9999 14.8334C24.8333 15.8334 24.8333 17.3334 23.9166 18.25L21.5833 20.5834L20.3333 19.3334L17.9999 21.6667C16.9166 22.75 15.4166 23.3334 13.9999 23.3334C14.1666 23.5834 14.3333 23.8334 14.5833 24.0834C16.2499 25.75 18.8333 25.75 20.4999 24.0834L25.2499 19.3334C26.9166 17.6667 26.9166 15.0834 25.2499 13.4167C24.8333 13.25 24.5833 13.0834 24.3333 12.9167Z"
      fill="#DBBE2C"
    />
  </svg>
);

export const blueDrug = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#C8D0FF" />
    <path
      d="M21.5002 10.9167C20.6668 10.0834 19.5835 9.66669 18.5835 9.66669C17.5835 9.66669 16.4168 10.0834 15.6668 10.9167L10.8335 15.5834C9.16683 17.25 9.16683 19.8334 10.8335 21.5C12.5002 23.1667 15.0835 23.1667 16.7502 21.5L21.5002 16.75C23.0835 15.1667 23.0835 12.5 21.5002 10.9167ZM20.3335 15.5834L18.0002 17.9167L15.0002 15L11.3335 18.6667C11.3335 18 11.5002 17.25 12.0835 16.75L16.8335 12C17.2502 11.5834 17.9168 11.3334 18.5002 11.3334C19.0835 11.3334 19.7502 11.5834 20.2502 12C21.2502 13.0834 21.2502 14.5834 20.3335 15.5834ZM24.3335 13.9167C24.3335 14.5834 24.1668 15.1667 24.0002 15.8334C24.8335 16.8334 24.8335 18.3334 23.9168 19.25L21.5835 21.5834L20.3335 20.3334L18.0002 22.6667C16.9168 23.75 15.4168 24.3334 14.0002 24.3334C14.1668 24.5834 14.3335 24.8334 14.5835 25.0834C16.2502 26.75 18.8335 26.75 20.5002 25.0834L25.2502 20.3334C26.9168 18.6667 26.9168 16.0834 25.2502 14.4167C24.8335 14.25 24.5835 14.0834 24.3335 13.9167Z"
      fill="#1E37D9"
    />
  </svg>
);

export const redDrug = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#E53935" fill-opacity="0.2" />
    <path
      d="M21.5002 10.9167C20.6668 10.0834 19.5835 9.66669 18.5835 9.66669C17.5835 9.66669 16.4168 10.0834 15.6668 10.9167L10.8335 15.5834C9.16683 17.25 9.16683 19.8334 10.8335 21.5C12.5002 23.1667 15.0835 23.1667 16.7502 21.5L21.5002 16.75C23.0835 15.1667 23.0835 12.5 21.5002 10.9167ZM20.3335 15.5834L18.0002 17.9167L15.0002 15L11.3335 18.6667C11.3335 18 11.5002 17.25 12.0835 16.75L16.8335 12C17.2502 11.5834 17.9168 11.3334 18.5002 11.3334C19.0835 11.3334 19.7502 11.5834 20.2502 12C21.2502 13.0834 21.2502 14.5834 20.3335 15.5834ZM24.3335 13.9167C24.3335 14.5834 24.1668 15.1667 24.0002 15.8334C24.8335 16.8334 24.8335 18.3334 23.9168 19.25L21.5835 21.5834L20.3335 20.3334L18.0002 22.6667C16.9168 23.75 15.4168 24.3334 14.0002 24.3334C14.1668 24.5834 14.3335 24.8334 14.5835 25.0834C16.2502 26.75 18.8335 26.75 20.5002 25.0834L25.2502 20.3334C26.9168 18.6667 26.9168 16.0834 25.2502 14.4167C24.8335 14.25 24.5835 14.0834 24.3335 13.9167Z"
      fill="#E53935"
    />
  </svg>
);

export const purpleStat = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="25" height="25" rx="4" fill="#EBE2FF" />
    <path
      d="M19.8537 18.464H3.17024C3.07661 18.464 3 18.5406 3 18.6343V19.826C3 19.9196 3.07661 19.9962 3.17024 19.9962H19.8537C19.9474 19.9962 20.024 19.9196 20.024 19.826V18.6343C20.024 18.5406 19.9474 18.464 19.8537 18.464ZM4.14273 15.7998L4.98755 16.6403C5.05352 16.7063 5.16205 16.7063 5.22801 16.6403L10.2224 11.663L12.2993 13.7335C12.4273 13.8603 12.6001 13.9314 12.7803 13.9314C12.9604 13.9314 13.1332 13.8603 13.2612 13.7335L18.8834 8.13261C18.9493 8.06664 18.9493 7.95811 18.8834 7.89214L18.0386 7.04945C18.0066 7.01777 17.9634 7 17.9183 7C17.8733 7 17.8301 7.01777 17.7981 7.04945L12.7824 12.0502L10.7034 9.97971C10.5754 9.85293 10.4026 9.7818 10.2224 9.7818C10.0423 9.7818 9.86945 9.85293 9.7415 9.97971L4.14273 15.5593C4.12682 15.575 4.11418 15.5938 4.10555 15.6144C4.09693 15.635 4.09248 15.6572 4.09248 15.6795C4.09248 15.7019 4.09693 15.7241 4.10555 15.7447C4.11418 15.7653 4.12682 15.7841 4.14273 15.7998Z"
      fill="#28105B"
    />
  </svg>
);

export const blueStat = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="25" height="25" rx="4" fill="#C7EBFF" />
    <path
      d="M19.8537 18.464H3.17024C3.07661 18.464 3 18.5406 3 18.6343V19.826C3 19.9196 3.07661 19.9962 3.17024 19.9962H19.8537C19.9474 19.9962 20.024 19.9196 20.024 19.826V18.6343C20.024 18.5406 19.9474 18.464 19.8537 18.464ZM4.14273 15.7998L4.98755 16.6403C5.05352 16.7063 5.16205 16.7063 5.22801 16.6403L10.2224 11.663L12.2993 13.7335C12.4273 13.8603 12.6001 13.9314 12.7803 13.9314C12.9604 13.9314 13.1332 13.8603 13.2612 13.7335L18.8834 8.13261C18.9493 8.06664 18.9493 7.95811 18.8834 7.89214L18.0386 7.04945C18.0066 7.01777 17.9634 7 17.9183 7C17.8733 7 17.8301 7.01777 17.7981 7.04945L12.7824 12.0502L10.7034 9.97971C10.5754 9.85293 10.4026 9.7818 10.2224 9.7818C10.0423 9.7818 9.86945 9.85293 9.7415 9.97971L4.14273 15.5593C4.12682 15.575 4.11418 15.5938 4.10555 15.6144C4.09693 15.635 4.09248 15.6572 4.09248 15.6795C4.09248 15.7019 4.09693 15.7241 4.10555 15.7447C4.11418 15.7653 4.12682 15.7841 4.14273 15.7998Z"
      fill="#13A7F6"
    />
  </svg>
);

export const lightGreenStat = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="25" height="25" rx="4" fill="#D9FFD3" />
    <path
      d="M19.8537 18.464H3.17024C3.07661 18.464 3 18.5406 3 18.6343V19.826C3 19.9196 3.07661 19.9962 3.17024 19.9962H19.8537C19.9474 19.9962 20.024 19.9196 20.024 19.826V18.6343C20.024 18.5406 19.9474 18.464 19.8537 18.464ZM4.14273 15.7998L4.98755 16.6403C5.05352 16.7063 5.16205 16.7063 5.22801 16.6403L10.2224 11.663L12.2993 13.7335C12.4273 13.8603 12.6001 13.9314 12.7803 13.9314C12.9604 13.9314 13.1332 13.8603 13.2612 13.7335L18.8834 8.13261C18.9493 8.06664 18.9493 7.95811 18.8834 7.89214L18.0386 7.04945C18.0066 7.01777 17.9634 7 17.9183 7C17.8733 7 17.8301 7.01777 17.7981 7.04945L12.7824 12.0502L10.7034 9.97971C10.5754 9.85293 10.4026 9.7818 10.2224 9.7818C10.0423 9.7818 9.86945 9.85293 9.7415 9.97971L4.14273 15.5593C4.12682 15.575 4.11418 15.5938 4.10555 15.6144C4.09693 15.635 4.09248 15.6572 4.09248 15.6795C4.09248 15.7019 4.09693 15.7241 4.10555 15.7447C4.11418 15.7653 4.12682 15.7841 4.14273 15.7998Z"
      fill="#4EE437"
    />
  </svg>
);

export const greenStat = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="25" height="25" rx="4" fill="#D7FDF5" />
    <path
      d="M19.8537 18.464H3.17024C3.07661 18.464 3 18.5406 3 18.6343V19.826C3 19.9196 3.07661 19.9962 3.17024 19.9962H19.8537C19.9474 19.9962 20.024 19.9196 20.024 19.826V18.6343C20.024 18.5406 19.9474 18.464 19.8537 18.464ZM4.14273 15.7998L4.98755 16.6403C5.05352 16.7063 5.16205 16.7063 5.22801 16.6403L10.2224 11.663L12.2993 13.7335C12.4273 13.8603 12.6001 13.9314 12.7803 13.9314C12.9604 13.9314 13.1332 13.8603 13.2612 13.7335L18.8834 8.13261C18.9493 8.06664 18.9493 7.95811 18.8834 7.89214L18.0386 7.04945C18.0066 7.01777 17.9634 7 17.9183 7C17.8733 7 17.8301 7.01777 17.7981 7.04945L12.7824 12.0502L10.7034 9.97971C10.5754 9.85293 10.4026 9.7818 10.2224 9.7818C10.0423 9.7818 9.86945 9.85293 9.7415 9.97971L4.14273 15.5593C4.12682 15.575 4.11418 15.5938 4.10555 15.6144C4.09693 15.635 4.09248 15.6572 4.09248 15.6795C4.09248 15.7019 4.09693 15.7241 4.10555 15.7447C4.11418 15.7653 4.12682 15.7841 4.14273 15.7998Z"
      fill="#0B7F68"
    />
  </svg>
);
